/* eslint-disable @typescript-eslint/no-redeclare */

import { types } from 'mobx-state-tree';

export const FetchState = types.enumeration('FetchState', ['notStarted', 'done', 'failed', 'canceled', 'gotFromCache']);
// eslint-disable-next-line no-redeclare
export type FetchState = typeof FetchState.Type;
